import { render, staticRenderFns } from "./AssetsAndProductsPage.vue?vue&type=template&id=4d0b6656&"
import script from "./AssetsAndProductsPage.vue?vue&type=script&lang=js&"
export * from "./AssetsAndProductsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports